import { Helper } from '../Helper';
export class BufferSliceHelper extends Helper {
    constructor({ hasEnd = false }) {
        super();
        this.hasEnd = hasEnd;
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        if (this.hasEnd) {
            sb.emitOp(node, 'ROT');
            sb.emitOp(node, 'SWAP');
            sb.emitHelper(node, options, sb.helpers.if({
                condition: () => {
                    sb.emitOp(node, 'TUCK');
                    sb.emitPushInt(node, 0);
                    sb.emitOp(node, 'LT');
                },
                whenTrue: () => {
                    sb.emitOp(node, 'TUCK');
                    sb.emitOp(node, 'SIZE');
                    sb.emitOp(node, 'ADD');
                    sb.emitOp(node, 'SWAP');
                },
            }));
            sb.emitOp(node, 'ROT');
            sb.emitHelper(node, options, sb.helpers.if({
                condition: () => {
                    sb.emitOp(node, 'TUCK');
                    sb.emitPushInt(node, 0);
                    sb.emitOp(node, 'LT');
                },
                whenTrue: () => {
                    sb.emitOp(node, 'TUCK');
                    sb.emitOp(node, 'SIZE');
                    sb.emitOp(node, 'ADD');
                    sb.emitOp(node, 'SWAP');
                },
            }));
            sb.emitOp(node, 'ROT');
            sb.emitOp(node, 'ROT');
            sb.emitHelper(node, options, sb.helpers.if({
                condition: () => {
                    sb.emitOp(node, 'TUCK');
                    sb.emitOp(node, 'OVER');
                    sb.emitOp(node, 'LTE');
                },
                whenTrue: () => {
                    sb.emitOp(node, 'DROP');
                    sb.emitOp(node, 'DROP');
                    sb.emitOp(node, 'DROP');
                    sb.emitPushBuffer(node, Buffer.alloc(0, 0));
                },
                whenFalse: () => {
                    sb.emitOp(node, 'TUCK');
                    sb.emitOp(node, 'SUB');
                    sb.emitOp(node, 'ROT');
                    sb.emitOp(node, 'ROT');
                    sb.emitOp(node, 'OVER');
                    sb.emitOp(node, 'SIZE');
                    sb.emitOp(node, 'SWAP');
                    sb.emitOp(node, 'SUB');
                    sb.emitOp(node, 'RIGHT');
                    sb.emitOp(node, 'SWAP');
                    sb.emitOp(node, 'LEFT');
                },
            }));
        }
        else {
            sb.emitHelper(node, options, sb.helpers.if({
                condition: () => {
                    sb.emitOp(node, 'DUP');
                    sb.emitPushInt(node, 0);
                    sb.emitOp(node, 'LT');
                },
                whenTrue: () => {
                    sb.emitPushInt(node, -1);
                    sb.emitOp(node, 'MUL');
                    sb.emitHelper(node, options, sb.helpers.if({
                        condition: () => {
                            sb.emitOp(node, 'TUCK');
                            sb.emitOp(node, 'OVER');
                            sb.emitOp(node, 'SIZE');
                            sb.emitOp(node, 'GT');
                        },
                        whenTrue: () => {
                            sb.emitOp(node, 'NIP');
                        },
                        whenFalse: () => {
                            sb.emitOp(node, 'SWAP');
                            sb.emitOp(node, 'RIGHT');
                        },
                    }));
                },
                whenFalse: () => {
                    sb.emitOp(node, 'OVER');
                    sb.emitOp(node, 'SIZE');
                    sb.emitOp(node, 'SWAP');
                    sb.emitOp(node, 'SUB');
                    sb.emitHelper(node, options, sb.helpers.if({
                        condition: () => {
                            sb.emitOp(node, 'TUCK');
                            sb.emitPushInt(node, 0);
                            sb.emitOp(node, 'LTE');
                        },
                        whenTrue: () => {
                            sb.emitOp(node, 'DROP');
                            sb.emitOp(node, 'DROP');
                            sb.emitPushBuffer(node, Buffer.alloc(0, 0));
                        },
                        whenFalse: () => {
                            sb.emitOp(node, 'SWAP');
                            sb.emitOp(node, 'RIGHT');
                        },
                    }));
                },
            }));
        }
    }
}

//# sourceMappingURL=BufferSliceHelper.js.map
